import React from "react";
import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import './cellFontSize.scss';

const ResponsiveTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    maxWidth: "500px",
  },
}));

const styles = {
  container: {
    padding: 5,
    textAlign: "center",
    background: "#fff",
  },
  header: {
    marginBottom: 2,
    color: "#231F20",
    fontSize: "16px",
  },
  subHeader: {
    color: "#C43A29",
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: 6,
  },
  cardContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 6,
    maxWidth: "480px",
  },
  card: (backgroundColor, borderColor) => ({
    backgroundColor,
    padding: 3,
    textAlign: "center",
    width: "auto",
    minWidth: "120px",
    maxWidth: "220px",
    height: "40px",
    borderRadius: "5px",
    border: `1px solid ${borderColor}`,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }),
  cardTitle: {
    fontSize: "12px",
    color: "#231F20",
  },
  cardValue: {
    fontSize: "13px",
    color: "#231F20",
    fontWeight: "bold",
  },
  icon: {
    cursor: "pointer",
    color: "#A0AEC0",
    fontSize: "12px",
  },
};

const CorporateAccessTooltip = ({data}) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" sx={{height: '1.2rem'}}>
      <Typography style={{ marginRight: 4, color: "#4C4E64DE" }} className="corporate-access-val">
        {data?.total || '-'}
      </Typography>
      <ResponsiveTooltip
        PopperProps={{
          modifiers: [
            {
              name: 'preventOverflow',
              enabled: true,
              options: {
                boundary: window,
                altAxis: true
              },
            },
            {
              name: 'flip',
              enabled: true,
            }
          ]
        }}
        title={
          <div style={styles.container}>
            <div style={styles.header}>Total Corporate Access</div>
            <div style={styles.subHeader}>({data?.total || '-'})</div>
            <Box style={styles.cardContainer}>
              <div style={styles.card("#e0f7fa", "#8BDBCD")}>
                <div style={styles.cardTitle}>Conference</div>
                <div style={styles.cardValue}>{data?.["conference"] ||0}</div>
              </div>
              <div style={styles.card("#e3f2fd", "#90CAF9")}>
                <div style={styles.cardTitle}>Corporate Roadshow</div>
                <div style={styles.cardValue}>{data?.["corporate roadshow"] ||0}</div>
              </div>
              <div style={styles.card("#fce4ec", "#F48FB1")}>
                <div style={styles.cardTitle}>Reverse Roadshow</div>
                <div style={styles.cardValue}>
                  {data?.["reverse roadshow"] ||0}
                </div>
              </div>
              <div style={styles.card("#e0f7fa", "#8BDBCD")}>
                <div style={styles.cardTitle}>Expert Roadshow</div>
                <div style={styles.cardValue}>{data?.["expert roadshow"] ||0}</div>
              </div>
              <div style={styles.card("#e3f2fd", "#90CAF9")}>
                <div style={styles.cardTitle}>Plant Visit/Site Visit</div>
                <div style={styles.cardValue}>{data?.["plant visit/site visit"] ||0}</div>
              </div>
              <div style={styles.card("#fce4ec", "#F48FB1")}>
                <div style={styles.cardTitle}>Yatra</div>
                <div style={styles.cardValue}>
                  {data?.["yatra"] ||0}
                </div>
              </div>
              <div style={styles.card("#fce4ec", "#F48FB1")}>
                <div style={styles.cardTitle}>Expert Series</div>
                <div style={styles.cardValue}>
                  {data?.["expert series"] ||0}
                </div>
              </div>
              <div style={styles.card("#e0f7fa", "#8BDBCD")}>
                <div style={styles.cardTitle}>Ambit Acuity</div>
                <div style={styles.cardValue}>{data?.["ambit acuity"] ||0}</div>
              </div>
              <div style={styles.card("#e3f2fd", "#90CAF9")}>
                <div style={styles.cardTitle}>Expert Meeting</div>
                <div style={styles.cardValue}>{data?.["expert meeting"] ||0}</div>
              </div>
              <div style={styles.card("#fce4ec", "#F48FB1")}>
                <div style={styles.cardTitle}>Corporate Meeting</div>
                <div style={styles.cardValue}>
                  {data?.["corporate meeting"] || 0}
                </div>
              </div>
            </Box>
          </div>
        }
        arrow
        placement="auto"
      >
        {!!data?.total && <InfoOutlinedIcon sx={styles.icon} />}
      </ResponsiveTooltip>
    </Box>
  );
};

export default CorporateAccessTooltip;
